// Image data for wedding gallery
export const weddingImages = [
  "https://cdn.mupende.com/u/mkJOy4.jpeg",
  "https://cdn.mupende.com/u/u17zqY.JPG",
  "https://cdn.mupende.com/u/Pt39Aa.jpeg",
  "https://cdn.mupende.com/u/LqrCud.jpeg",
  "https://cdn.mupende.com/u/XpUEeC.jpeg",
  "https://cdn.mupende.com/u/u6gHLB.jpeg",
  "https://cdn.mupende.com/u/dNkf7E.jpeg",
  "https://cdn.mupende.com/u/nat5OD.jpeg",
  "https://cdn.mupende.com/u/nHOZA6.jpeg",
  "https://cdn.mupende.com/u/NVwFUp.jpeg",
  "https://cdn.mupende.com/u/JCRfQS.jpeg",
  "https://cdn.mupende.com/u/LzNcKg.jpeg",
  "https://cdn.mupende.com/u/YJWPbQ.jpeg",
  "https://cdn.mupende.com/u/D073cD.jpeg",
  "https://cdn.mupende.com/u/3lnCYN.jpeg",
  "https://cdn.mupende.com/u/6AciKe.jpeg",
  "https://cdn.mupende.com/u/Yop9hN.jpeg",
];

export default weddingImages;
